

import logo from '../assets/image/logo.png'
import sign from '../assets/image/sign.png'
import { setComma } from '../helper/StringHelper';
import { wordifyfa } from '../helper/wordifyfa';


const TripReceipt = (props) => {
    return <div className="trip-receipts text-right m-0 p-3 w-100 ">
        <span className="d-flex justify-content-center align-items-center"><strong>{props.item.headerFactor}</strong></span>
        <div className=" d-flex justify-content-between align-items-center row mx-0 col-12 mt-3" style={{ flex: 1 }}>
            <div className="col-6 d-flex justify-content-start align-items-center " >
                <img
                    src={logo}
                    className="logo"
                />
            </div>
            <div className="col-6 d-flex flex-column justify-content-between align-items-end">
                <div className="d-flex justify-content-between align-items-center">
                    <span>تاریخ:</span>
                    <span className="details mx-1">{props.item.serviceDate}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <span>کد سفر:</span>
                    {console.log('sssssssssssssssssssss', props.item)}
                    <span className="details mx-1">{props.item.tripCode}</span>
                </div>
            </div>
        </div>
        <div className="w-100 d-flex flex-column justify-content-start align-items-center border bg-light rounded mt-2" style={{ flex: 3 }}>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                <span className="d-flex justify-content-start align-items-center">نام مسافر:</span>
                <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.passengerName}</span>
            </div>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2">
                <div className="d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                    <span className="d-flex justify-content-start align-items-center">نام راننده:</span>
                    <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.driverName}</span>
                </div>
                <div className="d-flex justify-content-start align-items-center row mx-1 mt-2 p-2">
                    <span className="d-flex justify-content-start align-items-center">پلاک خودرو:</span>
                    <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.plak}</span>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2">
                <div className="d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                    <span className="d-flex justify-content-start align-items-center">ساعت ورود:</span>
                    <span className="d-flex justify-content-start align-items-center text-left mx-1 details">{props.item.enterTime}</span>
                </div>
                <div className="d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                    <span className="d-flex justify-content-start align-items-center">ساعت خروج:</span>
                    <span className="d-flex justify-content-start align-items-center text-left mx-1 details">{props.item.exitTime}</span>
                </div>
            </div>

            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                <span className="d-flex justify-content-start align-items-center">مبدا:</span>
                <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.addr}</span>
            </div>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                <span className="d-flex justify-content-start align-items-center">مقصد:</span>
                <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.destination1}</span>
            </div>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0">
                <div className="d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                    <span className="d-flex justify-content-start align-items-center">کیلومتر سفر:</span>
                    <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.distance} کیلومتر</span>
                </div>
                <div className="d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                    <span className="d-flex justify-content-start align-items-center">تاخیر:</span>
                    <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.stopTime} دقیقه</span>
                </div>
            </div>

            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                <span className="d-flex justify-content-start align-items-center">توضیحات:</span>
                <span className="d-flex justify-content-start align-items-center mx-1 details">{props.item.descTript}</span>
            </div>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                <span className="d-flex justify-content-start align-items-center">مبلغ به عدد:</span>
                <span className="d-flex justify-content-start align-items-center mx-1 details bg-success px-2 rounded text-white">{setComma(props.item.price)}</span>
            </div>
            <div className="w-100 d-flex justify-content-start align-items-center row mx-0 mt-2 p-2">
                <span className="d-flex justify-content-start align-items-center">مبلغ به حروف:</span>
                <span className="d-flex justify-content-start align-items-center mx-1 details ">{wordifyfa(props?.item?.price?.replace('تومان', ''), 0)} تومان</span>
            </div>
        </div>

        <div className="w-100 d-flex flex-column justify-content-start align-items-center px-2" style={{ flex: 2 }}>
            <span className="mt-2">{props.item.descFactor}</span>
            <div className="w-100 d-flex flex-column justify-content-start align-items-start px-2" >
                <span>آدرس: {props.item.addrFactor}</span>
                <span>تلفن: {props.item.telFactor}</span>
            </div>
            <div className="w-100 d-flex justify-content-end align-items-center" >
                <span>مهر و امضا:</span>
                <img src={sign} className="sign mt-2" />
            </div>
        </div>
    </div>
}

export default TripReceipt;